/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ClaimShiftsState } from "common/types/ClaimShifts";
import Shift from "pages/Schedule/types/Shift";
import { api } from "store/api/shiftsApi";
import { getShiftStatus } from "store/slices/shiftClaimsPolling/utils";

const initialState = {} as ClaimShiftsState;

export const claimShiftsSlice = createSlice({
    initialState,
    name: "claimShifts",
    reducers: {
        setClaimDate: (state, action: PayloadAction<Date>) => {
            state.claimDate = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addMatcher(
            api.endpoints.getShiftClaimsStatuses.matchFulfilled,
            (state, { payload }) => {
                return {
                    ...state,
                    shifts: state.shifts?.map((shift) => {
                        const shiftClaimStatus = payload.find(
                            (shiftClaim) => shiftClaim.shiftId === shift.shiftId
                        );
                        return shiftClaimStatus
                            ? {
                                  ...shift,
                                  error: shiftClaimStatus.error?.errorKey,
                                  status: getShiftStatus(shiftClaimStatus.status),
                              }
                            : shift;
                    }),
                };
            }
        );
    },
});

export const claimDateSelector = createSelector(
    (state: any) => state.claimShifts,
    (claimShifts: ClaimShiftsState) => claimShifts.claimDate
);

export const claimShiftsMapSelector = createSelector(
    (state: any) => state.claimShifts.shifts,
    (shifts: Shift[]) =>
        shifts ? new Map(shifts.map((shift) => [shift.shiftId, shift])) : new Map()
);

// Reducer
export default claimShiftsSlice.reducer;
